require('./register_search')

// Autoload all components when the page is ready
const { autoload } = require('../../../js/document/load-queue')
autoload()
